// Centralised date/time formatting for the whole web app.
//
// The backend returns timestamps as ISO strings whose clock digits already ARE
// the intended wall-clock time (e.g. a task wanted for 18:00 is stored as
// "2026-07-31T18:00:00.000Z"). Passing such a string through `new Date()` makes
// the browser re-interpret it in its local timezone and shift the hour
// (Asia/Tashkent = UTC+5 → 18:00 wrongly shown as 23:00). To stay consistent
// regardless of the viewer's timezone, we read the Y/M/D H:M digits DIRECTLY
// from the string and never convert. Seconds are never displayed.

function parts(iso) {
  if (!iso) return null;
  const m = String(iso).match(/(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (!m) return null;
  return { y: m[1], mo: m[2], d: m[3], hh: m[4], mm: m[5] };
}

// "DD.MM.YYYY" — empty string if unparseable.
export function formatDate(iso) {
  const p = parts(iso);
  return p ? `${p.d}.${p.mo}.${p.y}` : '';
}

// "HH:mm" — empty string if the value carried no time component.
export function formatTime(iso) {
  const p = parts(iso);
  return p && p.hh ? `${p.hh}:${p.mm}` : '';
}

// "DD.MM.YYYY HH:mm" (falls back to just the date when no time is present).
export function formatDateTime(iso) {
  const p = parts(iso);
  if (!p) return '';
  return p.hh ? `${p.d}.${p.mo}.${p.y} ${p.hh}:${p.mm}` : `${p.d}.${p.mo}.${p.y}`;
}
